import type React from 'react'
import { cn } from '@/lib/utils'

type MobileLayoutProps = {
  children: React.ReactNode
  isShowBottomNavigation?: boolean
  className?: string
}

export function CustomerStaffLayout({ children, className }: MobileLayoutProps) {
  return (
    <div className='flex flex-col min-h-screen bg-[#F8FAFF] '>
      {/* Main content */}
      <main className={cn('flex-1 pb-8 overflow-y-auto', className)}>{children}</main>
    </div>
  )
}
